<!--
SDEV-FILE
Copyright (c) 2026 SDEV. All rights reserved.
Workspace: clientside
File: DiscoveryStep.vue
Created: 2026-03-13T17:39:06.588Z
-->

<template>

    <div class="sdev-wizard-step-content">

        <!-- HEADER -->

        <div class="sdev-wizard-step-content-header">

            <div class="header-left">
                <h1>{{ title }}</h1>
                <p>{{ version }}</p>
            </div>

            <div class="header-right">
                Step {{ actualStepInFlow }} of {{ totalStepsInFlow }}
            </div>

        </div>


        <!-- SOURCE STEP -->

        <div v-if="step === 'select_source'">

            <label>Select Data Source</label>

            <select v-model="selectedSource" class="sdev-select">
                <option disabled value="">Select source</option>
                <option v-for="s in sources" :key="s.key" :value="s.key">
                    {{ s.name }}
                </option>
            </select>

            <button class="sdev-button" @click="selectSource">
                Next
            </button>

        </div>


        <!-- ENDPOINT STEP -->

        <div v-if="step === 'endpoint'">

            <label>Endpoint URL</label>

            <input v-model="endpoint" class="sdev-input" placeholder="/api/product" />

            <button class="sdev-button" @click="startScan">
                Start Discovery
            </button>

        </div>


        <!-- SCAN RESULT -->

        <div v-if="step === 'inspect'">

            <h3>Discovered Schema</h3>

            <div class="sdev-card">

                <h4>Identities</h4>

                <ul>
                    <li v-for="i in preview.identities" :key="i.key">
                        {{ i.key }} ({{ i.type }})
                    </li>
                </ul>

            </div>

            <div class="sdev-card">

                <h4>Relations</h4>

                <ul>
                    <li v-for="r in preview.relations" :key="r.parent + r.child">
                        {{ r.parent }} → {{ r.child }}
                    </li>
                </ul>

            </div>

            <button class="sdev-button" @click="$emit('generateBlueprint')">
                Generate Blueprint
            </button>

        </div>


        <!-- BLUEPRINT PREVIEW -->

        <div v-if="step === 'blueprint'">

            <h3>Generated Blueprint</h3>

            <div class="sdev-card">

                <pre>{{ JSON.stringify(blueprint, null, 2) }}</pre>

            </div>

            <button class="sdev-button sdev-bg-surface-elevated" @click="$emit('saveBlueprint')">
                Save Blueprint
            </button>

        </div>


        <!-- DYNAMIC FORM -->

        <form v-else-if="fields.length" @submit.prevent="submit">

            <div v-for="f in fields" :key="f.name" class="sdev-form-field">

                <label>{{ f.name }}</label>

                <input v-if="f.type === 'text'" v-model="form[f.name]" class="sdev-input" required />

                <input v-else-if="f.type === 'password'" type="password" v-model="form[f.name]" class="sdev-input"
                    required />

            </div>

            <button class="sdev-button">
                Next
            </button>

        </form>

    </div>

</template>

<script setup>

import { ref, computed } from "vue"

const props = defineProps({

    step: String,

    data: Object,

    sources: Array,

    preview: Object,

    blueprint: Object,

    previewLoading: Boolean,

    totalStepsInFlow: Number,

    actualStepInFlow: Number

})

const emit = defineEmits([
    "next",
    "scan",
    "generateBlueprint",
    "saveBlueprint"
])

const selectedSource = ref(null)
const endpoint = ref(null)

const form = ref({})

const title = computed(() => props.data?.template_name || "Discovery")
const version = computed(() => props.data?.version || "")

const fields = computed(() => {

    if (!props.data?.wizard) return []

    const index = props.actualStepInFlow - 1

    return props.data.wizard[index]?.fields || []

})

function selectSource() {

    if (!selectedSource.value) return

    emit("next", {
        source: selectedSource.value
    })

}

function startScan() {

    if (!endpoint.value) return

    emit("scan", {
        endpoint: endpoint.value
    })

}

function submit() {

    emit("next", form.value)

}

</script>